//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";
export default {
  props: [
    "value",
    "label",
    "format",
    "disabled",
    "min",
    "max",
    "errorMessages",
  ],
  data() {
    return {
      menu: false,
    };
  },
  computed: {
    date: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        //debugger;
        this.$emit("input", value);
      },
    },
    formatDate() {
      return this.format && this.date
        ? moment(this.date).format(this.format)
        : this.date;
    },
  },
};
